import axios from "axios";
import { VERSION } from "../config";
const _MODULE = `/member/${VERSION}/customer`;
export default {
  /***
   * 客户详情
   */
  miniprogram(params) {
    return axios({
      url: `${_MODULE}/miniprogram/${params.customerId}`,
      method: `GET`
    });
  },
  /***
   * 根据客户id获取扫码二维码客户信息
   */
  detail(params) {
    return axios({
      url: `${_MODULE}/qrcode/info`,
      method: `GET`,
      params
    });
  }
};



// WEBPACK FOOTER //
// ./src/apis/src/customer.js